<template>
    <el-card
        class="tarification-grid read-only"
    >
        <div class="grid-header">
            <h2 class="title">{{list.name}}</h2>
            <el-button
                class="modify-button"
                type="primary"
                icon="ti-pencil"
                plain
                @click="changePricing()"
            ></el-button>
        </div>
        <div class="indicator" :class="{'active': isListInUse}">{{ isListInUse ? 'grille active' : 'grille non active'}}</div>
        <div class="tarif-grid">
            <el-row :gutter="0" class="labels">
                <el-col :span="18">
                    <div class="simulation-number">Nombre de simulations</div>
                </el-col>
                <el-col :span="6">
                    <div class="simulation-price">Prix</div>
                </el-col>
            </el-row>
            <GridRow
                v-for="(data, index) in list.values"
                :key="index"
                :data="data"
                class=""
            ></GridRow>
        </div>
    </el-card>
    
</template>

<script>

import GridRow from './gridRow.vue';

export default {
    props: {
        list: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        },
    },
    components: {
        GridRow,
    },
    data () {
        return {
        };
    },
    computed: {
        isListInUse() {
            return this.list.in_use;
        }
    },
    methods: {
        changePricing(){
            this.$emit('changePricingGrid', this.list);
        }
    }
};
</script>

<style lang="scss">
.tarification-grid {
    margin: 10px 0;
    min-height: 300px;
    .grid-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
            font-size: 20px;
            margin: 0;
        }
        .modify-button {
            padding: 6px 17px;
            font-size: 13px;
        }
    }
    .indicator {
        font-size: 12px;
        color: #F56C6C;
        margin-bottom: 10px;
        &.active {
            color: #67C23A;
        }
    }
    .tarif-grid {
        .labels {
            color: #9B9B9B;
            font-size: 10px;
            font-weight: bold;
            margin-bottom: 6px;
        }
    }
    .grid-row:nth-child(even) {
        background-color: #F3F3F3;
    }
    &:not(.read-only) {
        border: none;
        box-shadow: unset;
        .grid-header {
            justify-content: unset;
            .name-label {
                font-size: 13px;
            }
            .name-input-container {
                text-align: center;
                .name-input {
                    width: 80%;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Pricing/index.vue